import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { ControlPointStatusService } from '../../../shared/services/control-points/control-point-status.service';
import { ControlPointsStatusComponent } from '../../bookings/tagesdashboard-page/control-points-status/control-points-status.component';
import { HistoryPageComponent } from '../history-page/history-page.component';

/**
 * Standalone control-points overview for admin/inspector holders of
 * controlpoints.view who do NOT have kasse.use (so they cannot reach the
 * Tagesdashboard panel). Renders BOTH the live status panel and the check-in
 * history, so non-cashier viewers are not limited to history alone.
 */
@Component({
  selector: 'app-control-points-overview-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    ControlPointsStatusComponent,
    HistoryPageComponent,
  ],
  templateUrl: './status-page.component.html',
  styleUrl: './status-page.component.scss',
})
export class StatusPageComponent implements OnInit {
  #statusService = inject(ControlPointStatusService);

  ngOnInit(): void {
    // Start the live status poll (root-provided, idempotent). History is loaded
    // by the embedded HistoryPageComponent's own ngOnInit.
    this.#statusService.startPolling();
  }
}
